<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <div class="page_content">
      <div class="table_wrap" v-show="tableData.length > 0">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="light"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          header-row-class-name="table_header"
          header-cell-class-name="table_header_tr"
          class="creative_table"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="全选" width="160">
            <template slot-scope="scope">
              <img class="cart_table_img" :src="require('@/assets/img/goods/'+scope.row.CategoryKey+'/'+scope.row.GoodsPics)" v-if="scope.row.GoodsPics!='https://fakeimg.pl/250x100/'"/>
              <img class="cart_table_img" :src="scope.row.GoodsPics" v-else/>
            </template>
          </el-table-column>
          <el-table-column prop="CategoryDesc" label="创意类目" width="172">
          </el-table-column>
          <el-table-column prop="GoodsName" label="创意名称" width="254">
          </el-table-column>
          <el-table-column label="描述" width="342">
            <template slot-scope="scope">
              <el-popover
                width="344"
                trigger="hover"
                :content="scope.row.Desc"
              >
                <div slot="reference">
                  <div class="cart_table_desc">{{scope.row.Desc}}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column width="120" label="数量" header-align="center">
            <template slot-scope="scope">
              <el-input-number
                size="small"
                v-model="scope.row.GoodsCount"
                controls-position="right"
                style="width: 100px;"
                @change="goodsCountChange(scope.row.GoodsCount, scope.row.GoodsId)"
                :min="1"
                :max="999"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center">
            <template slot-scope="scope">
              <!--
              <el-popover
                placement="top"
                width="160"
                :value="visibleIndex === scope.row.GoodsId">
                <p class="popover_text"><img class="icon_hint" :src="require('@/assets/img/icon_hint.png')"/>您确定要将这条数据移出购物车吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visibleIndex =null">取消</el-button>
                  <el-button type="primary" size="mini" @click="delCart(scope.row.GoodsId)">确定</el-button>
                </div>
                <div  @click="visibleIndex = scope.row.GoodsId" slot="reference" class="cart_table_delete">
                  <img :src="require('@/assets/img/icon_delete.png')" />
                </div>
              </el-popover>
              -->
              <div  slot="reference" class="cart_table_delete" @click="removeCartBox(scope.row.GoodsId)" title="点击移除购物车">
                <img :src="require('@/assets/img/icon_delete.png')" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="empty_page" v-show="tableData.length == 0">
        <img :src="require('@/assets/img/shopping_cart_empty.png')"/>
        <p>您还没有添加任何创意商品</p>
      </div>
      <div class="cart_table_footer">
        <div class="cart_table_footer_content">
          <!--
            <el-checkbox v-model="checked" v-show="false">全部</el-checkbox>
            -->
          <div class="el-checkbox is-checked"></div>
          <div class="cart_table_footer_right">
            <span>已选{{checkedGoods.length}}个</span>
            <el-button
              type="primary"   class="cart_create_order" @click="orderBox">立即下单</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :visible.sync="orderVisible"
        width="680px"
        custom-class="order_modal"
        title="立即下单"
        @close="closeOrderBox"
    >
      <el-form
          :model="orderRuleForm"
          :rules="orderRules"
          ref="orderRuleForm"
          label-width="100px"
      >
        <el-form-item label="项目名称" prop="project_name">
          <el-input
              v-model="orderRuleForm.project_name"
              placeholder="请填写项目名称，最多30个汉字"
              maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item
            label="所选创意"
            prop="selected"
            class="originalityList"
        >
          <div  class="originality" v-for="(item, index) in selectedGoods" :key="index">
            <el-image
                style="width: 128px; height: 74px; border-radius: 4px"
                :src="require('@/assets/img/goods/'+item.CategoryKey+'/'+item.GoodsPics)" v-if="item.GoodsPics!='https://fakeimg.pl/250x100/'"
                :preview-src-list="[require('@/assets/img/goods/'+item.CategoryKey+'/'+item.GoodsPics)]"
                fit="cover">
            </el-image>
            <el-image
                style="width: 128px; height: 74px; border-radius: 4px"
                :src="item.GoodsPics"
                :preview-src-list="[item.GoodsPics]"
                fit="cover"
                v-else
            >
            </el-image>

            <div class="desc">
              <p>{{item.GoodsName}}</p>
              <el-input-number
                  v-model="item.GoodsCount"
                  :min="1"
                  :max="999"
                  label="数量"
                  controls-position="right"
              ></el-input-number>
            </div>
            <img
                :src="require('@/assets/img/icon_delete.png')"
                class="order_icon_delete"
                @click="handleDeleteOriginality(index)"
                v-show="selectedGoods.length > 1"
            />
          </div>
        </el-form-item>
        <el-form-item label="需求描述" prop="requirement">
          <el-input
              type="textarea"
              v-model="orderRuleForm.requirement"
              placeholder="请简要描述您的需求信息，可包含：创意风格、具体产出要求、预算区间、交付期限等。"
              rows="6"
              resize="none"
              maxlength="1000"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input
              v-model="orderRuleForm.name"
              placeholder="请输入姓名"
              maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
              v-model="orderRuleForm.phone"
              placeholder="请输手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="notes">
          <el-input
              v-model="orderRuleForm.notes"
              placeholder="如有其他要求，请在此填写"
              maxlength="1000"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件说明" prop="order_files">
          <el-upload
              class="upload-demo"
              name="order_files"
              :action="pubPrefix+upload_url"
              :multiple="true"
              :on-change="(file, fileList) => handleFileChange(4, file, fileList)"
              :data="{upload_type: '4'}"
              :on-success="(res, file, fileList) => handleFIleSuccess(4, res, file, fileList)"
              :before-upload="(file) => beforeFileUpload(4, file)"
              :before-remove="(file, fileList) => removeFileUpload(4, file, fileList)"
              :on-preview="mi_upload_handlepreview"
              :on-exceed="(files, fileList) => overFilelimit(4, files, fileList)"
              :on-progress="handleFileUploadProgress"
              :disabled="isUploading"
              :file-list="orderFileList"
              :headers="upload_headers"
              :limit="5"
              :show-file-list=true
              accept=".pdf, .ppt, .docx, .jpg, .jpeg, .png, .pptx ">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持pdf/ppt/docx/jpg/jpeg/png格式文件，最多上传5个附件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="place_order_bottone" style="height: 90px; line-height: 90px">
        <el-button class="modal_content_btn_submit" @click="orderVisible = false"
        >取消</el-button
        >
        <el-button
            class="modal_content_btn_submit"
            type="primary"
            @click="submitForm('orderRuleForm')"
        >下单</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
        :visible.sync="successVisible"
        width="680px"
        custom-class="success_modal"
    >
      <div class="modal_header">
        <img :src="require('@/assets/img/icon_successed@2x.png')"/>
        <p>下单成功</p>
      </div>
      <div class="content">
        <p class="first_text">
          请您添加星云企业微信客服为您提供专属服务
        </p>
        <p>您也可选择等待我们致电联系，我们将在<span style="color: #4573ff">30分钟内</span
        >与您联系</p>
        <img  :src="require('@/assets/img/qrcode.png')"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
// import axios from 'axios'
// import Cookies from 'js-cookie''
// eslint-disable-next-line
import * as commfun from '@/common/common.js'
import Cookies from 'js-cookie'
var pubPrefix = '/api'
export default {
  name: 'ShoppingCart',
  components: {
    Mainl
  },
  data: function () {
    return {
      checkedGoods: [],
      tableData: [],
      selectedGoods: [],
      successVisible: false, // 下单成功弹框

      orderVisible: false,
      orderRuleForm: {
        project_name: '',
        requirement: '',
        name: '',
        phone: '',
        notes: '',
        order_type: '2'
      },
      orderRules: {
        project_name: [
          { required: true, message: '请填写项目名称', trigger: 'blur' },
          { max: 30, message: '项目名称最多输入30个汉字', trigger: 'blur' }
        ],
        requirement: [
          { required: true, message: '请输入需求描述', trigger: 'blur' },
          { max: 1000, message: '需求描述最多输入1000个汉字', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 30, message: '姓名最多输入30个汉字', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur'}
        ],
        notes: [
          { max: 1000, message: '备注最多输入1000个汉字', trigger: 'blur' }
        ]
      },

      upload_url: '/api/index/upload',
      orderFileList: [],
      upload_headers: {},
      pubPrefix: pubPrefix,
      isUploading: false
    }
  },
  created () {
    this.orderRuleForm.name = Cookies.get('name')
    this.orderRuleForm.phone = Cookies.get('telphone')
  },
  mounted () {
    // 获取token设置header
    var Authorization = commfun.genAuthorization()
    this.upload_headers = {'Authorization': Authorization}
    this.initList()
  },
  methods: {
    // 列表数据
    initList: function () {
      var selfthis = this
      var url = pubPrefix + '/api/shopping_cart/list'
      var postdata = {}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (data == null || data === undefined) {
          selfthis.tableData = []
        } else {
          selfthis.tableData = data
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 修改商品数量
    goodsCountChange (goodsNum, goodsId) {
      var selfthis = this
      var url = pubPrefix + '/api/shopping_cart/add'
      var postdata = {
        goods_num: goodsNum,
        goods_id: goodsId,
        add_from: '2'
      }
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 移除购物车弹框
    removeCartBox (goodsId) {
      this.$confirm('确定将该商品移除购物车?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error',
        showClose: false
      }).then(() => {
        var selfthis = this
        // eslint-disable-next-line camelcase
        var url = pubPrefix + '/api/shopping_cart/add'
        var postdata = {
          goods_num: 0,
          goods_id: goodsId,
          add_from: '2'
        }
        commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
          for (var i = 0; i < selfthis.tableData.length; i++) {
            // 将数据移除购物车
            if (selfthis.tableData[i].GoodsId === goodsId) {
              selfthis.tableData.splice(i, 1)
            }
          }
        }, function (selfthis, dataError) {
          commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
        })
      }).catch(() => {
        // 取消移除购物车
      })
    },
    // 下单弹窗
    orderBox () {
      if (this.checkedGoods.length > 0) {
        this.orderVisible = true
        // this.selectedGoods = this.checkedGoods.concat()  // 这种方式是浅拷贝
        this.selectedGoods = JSON.parse(JSON.stringify(this.checkedGoods)) // 这种方式是深拷贝
      } else {
        commfun.showMessage(this, 'warning', '请选择商品进行下单！')
      }
    },
    // 关闭下单弹窗
    closeOrderBox () {
      this.selectedGoods = []
      for (var i in this.orderRuleForm) {
        this.orderRuleForm[i] = ''
      }
      this.orderRuleForm.order_type = '2'
      this.orderRuleForm.name = Cookies.get('name')
      this.orderRuleForm.phone = Cookies.get('telphone')
    },
    // 下单
    submitForm (formName) {
      var selfthis = this
      if (selfthis.isUploading) {
        commfun.showMessage(selfthis, 'warning', '附件上传中，请稍后！')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //附件
          var order_files = ''
          var file_list = selfthis.orderFileList
          if (file_list) {
            for (var j = 0; j < file_list.length; j++) {
              if (file_list[j]['url']) {
                file_list[j]['url1'] = encodeURIComponent(file_list[j]['url'])
                order_files +=   file_list[j]['annex'] + '|' + file_list[j]['hash'] + '|' + file_list[j]['type'] + '|' + file_list[j]['filename'] + '|' + file_list[j]['filesize'] + '|' + file_list[j]['url1'] + '|' + file_list[j]['uid'] + '|' + file_list[j]['username'] + '|' + file_list[j]['datetime'] + ',';
              } else {
                var file_temp = file_list[j]['response']['data']
                file_temp['url1'] = encodeURIComponent(file_temp['url'])
                order_files +=   file_temp['annex'] + '|' + file_temp['hash'] + '|' + file_temp['type'] + '|' + file_temp['filename'] + '|' + file_temp['filesize'] + '|' + file_temp['url1'] + '|' + file_temp['uid'] + '|' + file_temp['username'] + '|' + file_temp['datetime'] + ',';
              }
            }
            order_files = order_files.slice(0, order_files.length - 1);
          }
          var goodsInfo = {}
          for (var i = 0; i < selfthis.selectedGoods.length; i++) {
            goodsInfo[selfthis.selectedGoods[i].GoodsId] = selfthis.selectedGoods[i].GoodsCount
          }
          var url = pubPrefix + '/api/order/create'
          var postdata = selfthis.orderRuleForm
          postdata.order_files = order_files
          postdata.goods_info = JSON.stringify(goodsInfo)
          commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
            // 下单成功关闭下单弹框，打开下单成功二维码弹框，然后调用获取购物车列表方法，刷新购物车数据
            selfthis.orderVisible = false
            selfthis.successVisible = true
            selfthis.initList()
          }, function (selfthis, dataError) {
            commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
          })
        } else {
          return false
        }
      })
    },
    // 下单弹框删除商品数据
    handleDeleteOriginality (index) {
      this.selectedGoods.splice(index, 1)
    },

    handleFileChange(index, file, fileList) {
    },//上传文件
    handleFileUploadProgress (event, file, fileList) {
      this.isUploading = true;
    },
    // 上传完成
    async handleFIleSuccess(index, res, file, fileList) {
      var selfthis = this
      if (res.code != 1000) {
        fileList.pop()
        if (res.msg != undefined && res.msg != '') {
          this.$message.error(res.msg);
        }
        return false;
      }
      res.data.status="success"
      res.data.name=file.name
      res.data.url=res.data.fileurl
      res.data.type = 1
      selfthis.orderFileList = fileList
      selfthis.isUploading = false;
    },//handleFIleSuccess
    // 上传文件
    beforeFileUpload(index, file, fileList){
      // this.upload_data['_csrf-backend'] = csrfToken;
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["pdf", "ppt", "pptx", "docx", "jpg", "jpeg", "png", "PDF","PPT", "PPTX", "DOCX", "JPG", "JPEG", "PNG"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        var msg = '只能上传pdf/ppt/docx/jpg/jpeg/png格式文件!'
        this.$message.error(msg);
        return false;
      }else{
        const isLt2M = file.size / 1024 / 1024 < 100;
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        const isJPG = true;
        return isJPG && isLt2M;
      }
    },
    // 移除文件
    removeFileUpload(index, file, fileList){
      this.orderFileList = fileList
    },
    // 打开文件
    mi_upload_handlepreview:function(file){
      if(file.response){
        window.open(file.response.data.fileurl)
      }else{
        window.open(file.fileurl)
      }
    },
    // 限制文件个数
    overFilelimit(index, files, fileList){
      this.$message.error('最多上传5个附件!');
    },

    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.checkedGoods = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShoppingCart.vue